import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

export const StyledMonitorIcon = styled(Flexer.Parent).attrs(() => ({
  justifyContent: 'center',
  alignItems: 'center',
}))`
  width: ${(props) => props.theme.base.gridSizes.M};
  height: ${(props) => props.theme.base.gridSizes.M};
  border-radius: ${(props) => props.theme.base.gridSizes.XS};
  background: var(--orangePeach);
  color: var(--white);
  font-size: 17px;
  font-weight: 600;
`;
